<template>
  <main>
    <header-section></header-section>
    <table-section></table-section>
    <method-section></method-section>
  </main>
</template>

<script>
  import HeaderSection from '@/components/HeaderSection';
  import TableSection from '@/components/TableSection';
  import MethodSection from '@/components/MethodSection';
export default {
  name: 'App',
  components: {
    HeaderSection,
    TableSection,
    MethodSection,
  }
}
</script>

<style lang="scss">

@font-face {
  font-family: 'BigShouldersDisplay';
  src: local('BigShouldersDisplay'), url('./assets/fonts/BigShouldersDisplay-Regular.ttf') format('truetype'),
}

@font-face {
  font-family: 'BigShouldersText';
  src: local('BigShouldersText'), url('./assets/fonts/BigShouldersText-Regular.ttf') format('truetype'),
}

@font-face {
  font-family: 'OpenSans-ExtraBold';
  src: local('OpenSans-ExtraBold'), url('./assets/fonts/OpenSans-ExtraBold.ttf') format('truetype'),
}

@font-face {
  font-family: 'OpenSans';
  src: local('OpenSans'), url('./assets/fonts/OpenSans-Regular.ttf') format('truetype'),
}

body, html {
  margin:0;
  padding:0;
  font-family: OpenSans, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size:16px;
  color:$white;
}


h1 {
  font-family: BigShouldersText, sans-serif;
  font-style: none;
  font-weight: normal;
  margin: 0px;
  padding: 0px;
}

h2,h3,h4 {
  font-family: OpenSans-ExtraBold, sans-serif;
  font-style: none;
  font-weight: normal;
  margin: 0px;
  padding: 0px;
}

a {
  color: $text-blue;
}

</style>
